export * from './vds-page-header.component';
//export * from './vds-page-header.module';